// Amplitude event names. Taxonomy rules: all lowercase, `<feature area>: <action>`
// format, never inline strings in feature code — add a member here instead.
// Check the approved-names sheet before inventing a new name; the shared
// project has hard caps on event types.
export enum EventName {
  Pageview = "pageview",
  // A user stepping to a citation in the Evidence Walkthrough (click or arrow key).
  ViewEvidenceWalkthrough = "autonomous testing workflow: view evidence walkthrough",
  // A user selecting an option in an audit list's filter bar.
  CreateTableFilter = "table: create filter",
}
